/* eslint-disable new-cap, babel/new-cap */

import { Record } from "immutable"
import { FORM_FIELDS } from "@kiwicom/frontend-common/consts/form"

import DatePairCorrector from "../tools/DatePairCorrector"

const { OUTBOUND_DATE, INBOUND_DATE } = FORM_FIELDS

// search form
// ===

export const ActiveModesRecord = Record({
  origin: null,
  destination: null,
  outboundDate: null,
  inboundDate: null,
})

// handlers
// ===

/**
 * @param form {SearchFormState} or such
 * @param value {SearchDate|SearchPlace}
 * @param field - one of FORM_FIELDS
 */
export function handleFormChange(form, value, field) {
  let change = form.set(field, value)

  if (field === OUTBOUND_DATE || field === INBOUND_DATE) {
    change = DatePairCorrector(change, field)
  }

  return change
}
